"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGibInfo = exports.getGib = exports.isPrimitive = exports.isDna = exports.buildDna = void 0;
const helper_1 = require("../../helper");
const sha256v1_1 = require("../sha256v1");
const constants_1 = require("../constants");
function buildDna(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const transformData = (0, helper_1.clone)(opts);
        let lc = `[${buildDna.name}]`;
        // remove references to the srcAddr, as this will be captured
        // by the ibGib's `past` rel8n. This way, we can reapply dna
        // to different src's more easily, as well as have less unique dna
        if (transformData.srcAddr) {
            delete transformData.srcAddr;
        }
        // remove all references to actual objects in this, we just
        // want the data. ATOW, src is a reference to the src object
        // and we only want the srcAddr
        delete transformData.src;
        // dna is never timestamped or uniquely identified hmm...
        // or rel8d to anything...hmmm
        // so much dna, best to minimize though of course we dont
        // want to prematurely optimize...but there's a looooot of dna.
        // best to share/reuse as much as possible.
        const result = {
            ib: transformData.type,
            data: transformData,
            rel8ns: { ancestor: [
                    `${transformData.type.toString()}${constants_1.IBGIB_DELIMITER}${constants_1.GIB}` // e.g. fork^gib
                ] }
        };
        result.gib = yield (0, sha256v1_1.sha256v1)(result);
        return result;
    });
}
exports.buildDna = buildDna;
function isDna({ ibGib }) {
    const lc = `[${isDna.name}]`;
    try {
        if (!ibGib) {
            throw new Error(`ibGib required.`);
        }
        // console.log(`${lc} ibGib: ${pretty(ibGib)}`);
        // ancestor is known transform is the best way for v1 ATOW
        const knownTransformPrimitiveAddrs = ['fork', 'mut8', 'rel8', 'plan'].map(x => `${x}^${constants_1.GIB}`); // plan from prev versions
        const hasTransformAncestor = (ibGib.rel8ns) &&
            (ibGib.rel8ns.ancestor) &&
            (Array.isArray(ibGib.rel8ns.ancestor)) &&
            (ibGib.rel8ns.ancestor).
                some(x => knownTransformPrimitiveAddrs.includes(x));
        return hasTransformAncestor || false;
    }
    catch (error) {
        console.error(`${lc} ${error.message}`);
        throw error;
    }
}
exports.isDna = isDna;
function isPrimitive({ ibGib, gib }) {
    if (ibGib) {
        return isPrimitive({ gib: ibGib.gib });
    }
    else if (gib) {
        return gib === constants_1.GIB;
    }
    else {
        // falsy gib means it's primitive or a programming error...hmm
        return true;
    }
}
exports.isPrimitive = isPrimitive;
/**
 * Generates the gib of a given `ibGib` depending on
 * @returns gib - either bare hash for those with no tjp; or tjp-scoped hash; or 'gib' for primitives
 */
function getGib({ ibGib, hasTjp, tjpAddr, gibDelimiter, isPrimitive, hashAlgorithm, }) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const lc = `[${getGib.name}]`;
        try {
            if (!ibGib) {
                throw new Error(`ibGib required. (E: 17d073226b9d42fd841e5a94b065ef21)`);
            }
            if (isPrimitive) {
                return constants_1.GIB;
            }
            const ibGibHash = yield (0, sha256v1_1.sha256v1)(ibGib, '');
            const rel8ns = (_a = ibGib.rel8ns) !== null && _a !== void 0 ? _a : {};
            const data = (_b = ibGib.data) !== null && _b !== void 0 ? _b : {};
            gibDelimiter = gibDelimiter || constants_1.GIB_DELIMITER;
            if (!hasTjp) {
                hasTjp = ((_d = (_c = rel8ns.tjp) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : []) > 0 || data.isTjp || false;
            }
            if (hasTjp) {
                let tjpAddrGib;
                if (rel8ns.tjp) {
                    if (rel8ns.tjp.length === 1) {
                        if (rel8ns.tjp[0]) { // checking for empty string
                            tjpAddr = rel8ns.tjp[0];
                        }
                        else {
                            throw new Error(`rel8ns.tjp[0] is falsy. (E: ed879d2b039543f8b1902e8b7b5a5a7b)`);
                        }
                    }
                    else if (rel8ns.tjp.length > 1) {
                        if (rel8ns.tjp[rel8ns.tjp.length - 1]) {
                            console.warn(`${lc} found more than one tjp addr...only expecting 1 ATOW. (W: 10ed43f716e743e0afd1954f1ab46789)`);
                            tjpAddr = rel8ns.tjp[rel8ns.tjp.length - 1];
                        }
                        else {
                            throw new Error(`multiple tjp addrs, and the last (most recent) one is falsy. (E: bc835dc89be24075bba8b2b6616ea069)`);
                        }
                    }
                    else {
                        // empty rel8ns.tjp array?
                        throw new Error(`hasTjp is true but rel8ns.tjp is empty array. (E: d08b2f9e86494814b5e7d7b4602b2ab7)`);
                    }
                }
                else if (data.isTjp) {
                    // the ibGib itself is the tjp
                    tjpAddr = (0, helper_1.getIbGibAddr)({ ib: ibGib.ib, gib: ibGibHash });
                }
                else {
                    throw new Error(`hasTjp is true, but both ibGib.rel8ns.tjp and ibGib.data.isTjp are falsy. (E: 4e246897e52044789594d853bb5b66ee)`);
                }
                tjpAddrGib = tjpAddr ? (0, helper_1.getIbAndGib)({ ibGibAddr: tjpAddr }).gib : undefined;
                if (tjpAddrGib) {
                    // if the ibGib IS the tjp, then the gib is only the hash
                    // if the ibGib is NOT the tjp, then the gib is the hash plus
                    // tjpGib. note in the future, if multiple tjps are going, then
                    // tjpAddrGib itself may have another delim inside it, so we
                    // will end up with a gib with multiple delimiters.
                    return data.isTjp ? ibGibHash : `${ibGibHash}${constants_1.GIB_DELIMITER}${tjpAddrGib}`;
                }
                else {
                    throw new Error(`hasTjp is true but could not find tjpAddrGib. (E: 1863df626b754744a1d431a683cb0ba0)`);
                }
            }
            else {
                // no tjp, so gib is just the hash
                return ibGibHash;
            }
        }
        catch (error) {
            console.error(`${lc} ${error.message}`);
            throw error;
        }
    });
}
exports.getGib = getGib;
/**
 * Parses gib (either via `gib` param or `ibGibAddr.gib`) and returns information
 * about it.
 *
 * @returns Information about the given `gib` (or `gib` extracted from `ibGibAddr`)
 */
function getGibInfo({ ibGibAddr, gib, gibDelimiter, }) {
    const lc = `[${getGibInfo.name}]`;
    try {
        if (!ibGibAddr && !gib) {
            throw new Error(`Either ibGibAddr or gib required. (E: 25e3dcbe63cd44909032df12af9df75e)`);
        }
        gib = gib || (0, helper_1.getIbAndGib)({ ibGibAddr }).gib;
        if (gib === constants_1.GIB) {
            return { isPrimitive: true };
        }
        gibDelimiter = gibDelimiter !== null && gibDelimiter !== void 0 ? gibDelimiter : constants_1.GIB_DELIMITER;
        if (gib.includes(gibDelimiter)) {
            const pieces = gib.split(gibDelimiter);
            if (pieces.some(p => p === '')) {
                throw new Error(`unexpected gib that contains gibDelimiter (${gibDelimiter}) but has at least one piece with empty string. (E: 75a94280045541009ee68182d12d3449)`);
            }
            const piecesCount = pieces.length;
            if (piecesCount > 2) {
                console.warn(`${lc} gib only expected to have two pieces ATOW. re-examine please. (W: aa4283ac5a5747a386a69966ecdad39d)`);
            }
            const punctiliarHashPiece = pieces.splice(0, 1);
            return {
                punctiliarHash: punctiliarHashPiece[0],
                tjpGib: pieces.join(gibDelimiter),
                piecesCount,
                delimiter: gibDelimiter,
            };
        }
        else {
            return {
                punctiliarHash: gib,
                piecesCount: 1,
                delimiter: gibDelimiter,
            };
        }
    }
    catch (error) {
        console.error(`${lc} ${error.message}`);
        throw error;
    }
}
exports.getGibInfo = getGibInfo;
